// ─── Calendar Year Route ───
// /app/calendar-year — the personal, at-a-glance 12-month day-type overview
// (ADR 0017, Phase 9 Batch D5). See YearView.tsx for the "why a top-level
// route, not a Settings sub-tab" placement rationale.

import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { YearView } from '../../features/calendar/YearView';

// Batch 6 vacations UX arc (docs/design/vacations-ux.md §1.2) — an optional
// pre-arm for the "Mi año" tab's ask mode, set by `MyVacationPanel`'s
// deep-link CTA (`search={{ ask: true }}`). Absent/false is a fully
// functional fallback (spec §1.2): the user just lands on the tab and clicks
// "Solicitar vacaciones" once more.
//
// `.catch(undefined)` (not a bare `.optional()`) is load-bearing: a garbage
// `?ask=notabool` deep link must DEGRADE to the browse-mode fallback above,
// not throw/redirect — exported so a direct unit test (panel finding
// UNVE-19, 2026-07-17) can pin that degradation without needing a full
// router test harness (YearView.test.tsx stubs `useSearch` directly, so
// this schema is never actually executed by any component-level test).
export const calendarYearSearchSchema = z.object({
  ask: z.boolean().optional().catch(undefined),
});

export const Route = createFileRoute('/app/calendar-year')({
  validateSearch: calendarYearSearchSchema,
  component: YearView,
});
